module.exports = "<div id=\"otp-expire-dialog\" class=\"modal-style xl-flexbox xl-center\">\n    <div class=\"modal-in small-screen-overflow\">\n        <div class=\"modal-in__body mobile-padding\">\n            <h3>\n                <span translate>noAuth.otp.resend.title</span>\n            </h3>\n            <p translate>noAuth.otp.resend.text</p>\n            <span class=\"close-modalB btn btn-primary talep-kapat\" ng-click=\"$ctrl.onClick()\">\n                <span translate>common.button.ok</span>\n            </span>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/no-auth/components/otp-expire-dialog/otp-expire-dialog.html
// module id = 472
// module chunks = 0